// variables
import { themeOptions } from 'variables';

// libraries
import { Select } from 'antd';
import styled from 'styled-components';

export const StyledSelect = styled(Select)`
  min-width: 140px;
  width: 100%;

  .ant-select-selection-placeholder {
    padding-left: 12px !important;
  }

  img {
    width: 24px;
    height: 24px;
  }

  &.ant-select-borderless {
    &.ant-select-status-error {
      border-bottom: 1px solid ${themeOptions.palette.primary.base} !important;
    }
  }

  .ant-select-selector {
    .ant-select-selection-item {
      padding-left: 12px;
      font-size: 14px;
    }
  }

  .ant-select-arrow {
    margin-right: 10px;
  }
`;
